module.exports = __webpack_public_path__ + "static/media/rhyme.d391eced.svg";